import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import filterParams from './modules/filterParams'
import selected from './modules/selected'
import user from './modules/user'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    filterParams,
    selected,
    user
  },
  plugins: [
    createPersistedState({
      // 여기에 쓴 만 새로고침시에도 저장 됩니다.
      paths: ['selected', 'filterParams', 'user']
    })
  ]
})



// WEBPACK FOOTER //
// ./src/app/store/index.js